import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Bikeatac from './Bikeatac';

// ==================================================================================================
function setWindowProp(key: string, value: unknown): void {
  window[key] = value;
}

// ==================================================================================================
setWindowProp('Bikeatac', Bikeatac);
